import { render, staticRenderFns } from "./payment-user-page.vue?vue&type=template&id=a2686e1e&scoped=true"
import script from "./payment-user-page.vue?vue&type=script&lang=js"
export * from "./payment-user-page.vue?vue&type=script&lang=js"
import style0 from "./payment-user-page.vue?vue&type=style&index=0&id=a2686e1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2686e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2686e1e')) {
      api.createRecord('a2686e1e', component.options)
    } else {
      api.reload('a2686e1e', component.options)
    }
    module.hot.accept("./payment-user-page.vue?vue&type=template&id=a2686e1e&scoped=true", function () {
      api.rerender('a2686e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/payment-user-info/payment-user-page.vue"
export default component.exports